// extracted by mini-css-extract-plugin
export var closeIcon = "sign-up-module--close-icon--026e8";
export var closed = "sign-up-module--closed--0b1c2";
export var imageContainer = "sign-up-module--image-container--bef2d";
export var popup = "sign-up-module--popup--4f139";
export var signUpButton = "sign-up-module--sign-up-button--af043";
export var signUpContainer = "sign-up-module--sign-up-container--08948";
export var signUpContent = "sign-up-module--sign-up-content--30a9c";